import { api } from '../core';

type GetLoginStatusResponse = object;

type GetLoginStatusProps = {
  abortController?: AbortController;
};

const getLoginStatusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLoginStatus: builder.query<GetLoginStatusResponse, GetLoginStatusProps>({
      query: ({ abortController = new AbortController() }: GetLoginStatusProps) => ({
        url: `login/status`,
        method: 'GET',
        signal: abortController.signal
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getLoginStatus in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetLoginStatusQuery } = getLoginStatusApi;
